export default {
	thin: "text-weight--thin",
	"ultra-light": "text-weight--ultra-light",
	light: "text-weight--light",
	normal: "text-weight--normal",
	medium: "text-weight--medium",
	semi: "text-weight--semi",
	bold: "text-weight--bold",
	extra: "text-weight--extra",
	heavy: "text-weight--heavy",
};
